export const FIELD_KEYS = {
  managerName: '이름',
  contactNo: '연락처',
  mobilePhone: '휴대폰번호',
  department: '부서',
  position: '직급',
};

export const REQUIRED_MANAGER_KEYS = ['managerName', 'mobilePhone'];
